import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

function Header() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <header className={`navbar ${menuOpen ? "active" : ""}`}>
      <Link to="/" className="navbar-title-link" onClick={closeMenu}>
        <h1 className="navbar-title">Chennai Home Appliance Care</h1>
      </Link>

      <div className={`hamburger ${menuOpen ? "active" : ""}`} onClick={handleMenuToggle}>
        &#9776; {/* Hamburger icon */}
      </div>

      <nav className={`navbar-links ${menuOpen ? "show" : ""}`}>
        <Link to="/" className="nav-link" onClick={closeMenu}>
          Home
        </Link>

        {/* Service link with dropdown */}
        <div className="dropdown" onClick={handleDropdownToggle}>
          <button className="nav-link dropdown-toggle">
            Services
          </button>
          {dropdownOpen && (
            <div className="dropdown-menu">
              <Link
                to="/washing-machine-service"
                className="dropdown-item"
                onClick={closeMenu}
              >
                Washing Machine Service
              </Link>
              <Link to="/fridge-service" className="dropdown-item" onClick={closeMenu}>
                Fridge Service
              </Link>
            </div>
          )}
        </div>

        <Link to="/about" className="nav-link" onClick={closeMenu}>
          About
        </Link>
        <Link to="/contact" className="nav-link" onClick={closeMenu}>
          Contact
        </Link>
      </nav>
    </header>
  );
}

export default Header;
